import React, { useContext, useMemo, useCallback, useState } from 'react';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { PickPlatformView } from '@bingads-webui-campaign-react/edit-website-pages';
import { StepContainer } from '@bingads-webui-campaign-react/goal-creation-wizard';
import { UetSetupWizardContext } from '../../uet-setup-wizard-context';
import { WIZARD_ACTIONS } from '../../uet-setup-wizard-reducer';

const TagSetupThirdPartyPlatformStepUnwrapped = () => {
  const i18n = useContext(I18nContext);
  const wizardContext = useContext(UetSetupWizardContext);
  const { logActivity } = wizardContext;
  const [selectedPlatform, setSelectedPlatform] = useState(null);

  const handleCancel = useCallback(() => {
    wizardContext.exitWizard();
  }, [wizardContext]);

  const handleNext = useCallback(() => {
    logActivity.trace(`[ThirdPartyPlatform] selected platform: ${selectedPlatform}`);
    wizardContext.dispatch({
      type: WIZARD_ACTIONS.NAVIGATE_WITH_PLATFORM,
      data: {
        selectedPlatform,
      },
    });
  }, [logActivity, selectedPlatform, wizardContext]);

  const footerConfig = useMemo(() => ({
    buttons: [{
      type: 'Secondary',
      onClick: wizardContext.goBack,
      isEnabled: true,
      text: i18n.getString(_TL_(('Back'))),
    },
    {
      type: 'Primary',
      onClick: handleNext,
      isEnabled: !!selectedPlatform,
      text: i18n.getString(_TL_(('Next'))),
    },
    {
      type: 'Cancel',
      onClick: handleCancel,
      isEnabled: true,
      text: i18n.getString(_TL_(('Cancel'))),
    }],
  }), [wizardContext.goBack, handleCancel, handleNext, selectedPlatform, i18n]);

  const onChangePlatforms = useCallback((platform) => {
    setSelectedPlatform(platform);
  }, []);

  return (
    <StepContainer
      subContainer
      step="tag-setup-selection"
      footerConfig={footerConfig}
      title={i18n.getString(_TL_('Choose your website platform'))}
    >
      <PickPlatformView
        isSmartOrExpertMode
        onChangePlatforms={onChangePlatforms}
      />
    </StepContainer>
  );
};

export const TagSetupThirdPartyPlatformStep = TagSetupThirdPartyPlatformStepUnwrapped;
